import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function injectResourceHints() {
  if (typeof document === 'undefined') return;
  const head = document.head;
  const hints: {
    rel: string;
    href: string;
    as?: string;
    crossOrigin?: string;
  }[] = [{
    rel: 'preconnect',
    href: 'https://cdn.magicpatterns.com',
    crossOrigin: ''
  }, {
    rel: 'dns-prefetch',
    href: 'https://cdn.magicpatterns.com'
  }, {
    rel: 'preconnect',
    href: 'https://fonts.googleapis.com'
  }, {
    rel: 'preconnect',
    href: 'https://fonts.gstatic.com',
    crossOrigin: ''
  }, {
    rel: 'preload',
    as: 'image',
    href: 'https://cdn.magicpatterns.com/uploads/c15xhKgrGPAEXqeuowRmPs/lengua_mock.png?w=640&q=72&auto=format'
  }];
  hints.forEach(h => {
    const link = document.createElement('link');
    link.rel = h.rel;
    link.href = h.href;
    if (h.as) link.setAttribute('as', h.as);
    if (h.crossOrigin !== undefined) link.crossOrigin = h.crossOrigin;
    head.appendChild(link);
  });
})();
render(<App data-id="element-318" />, document.getElementById('root'));